<div class="blade-wrapper">
  <div class="blade-header">
    <div  class="blade-tools">
        <app-toolbar [toolbar]="toolbar">
            <ng-template 
              toolbarToolDef="confirm" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly || tool.control.disabled"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      (click)="on_confirm_clicked($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
            <ng-template 
              toolbarToolDef="cancel_button" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly || tool.control.disabled"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      (click)="on_cancel_clicked($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
        </app-toolbar>
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-form">
      <ng-container *ngIf="initialized ">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-Configuration"
                     *ngIf="!fieldsets.Configuration.hidden && !fieldsets.Configuration.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.Configuration.collapsible }">
                    <div *ngIf="!fieldsets.Configuration.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.Configuration.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.Configuration.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.Configuration.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.Configuration.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.Configuration.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.Configuration.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-warehouse" *ngIf="!fields.warehouse.hidden && !fields.warehouse.removed" 
                            class="field-container double {{fields.warehouse.invalid ? 'invalid' : ''}} {{fields.warehouse.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.warehouse.styles.style"
                            [ngClass]="fields.warehouse.styles.classes">
                        <div *ngIf="fields.warehouse.label" class="label-container"
                             [matTooltip]="fields.warehouse.tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.warehouse.label}}<span *ngIf="fields.warehouse.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <ProgrammableLogicController-warehouses_dd_single 
                            data-cy="selector"
                            [type]="fields.warehouse.control.type"
                            formControlName="warehouse"
                            (displayTextChange)="fields.warehouse.control.displayText=$event"
                            [placeholder]="fields.warehouse.control.placeholder"
                            [styles]="fields.warehouse.control.styles"
                            [tooltip]="fields.warehouse.control.tooltip"
                        >
                        </ProgrammableLogicController-warehouses_dd_single>
                        <ng-container *ngIf="fields.warehouse.invalid">
                          <ng-container *ngFor="let error of fields.warehouse.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-project" *ngIf="!fields.project.hidden && !fields.project.removed" 
                            class="field-container double {{fields.project.invalid ? 'invalid' : ''}} {{fields.project.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.project.styles.style"
                            [ngClass]="fields.project.styles.classes">
                        <div *ngIf="fields.project.label" class="label-container"
                             [matTooltip]="fields.project.tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.project.label}}<span *ngIf="fields.project.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <ProgrammableLogicController-projects_dd_single 
                            data-cy="selector"
                            [type]="fields.project.control.type"
                            formControlName="project"
                            (displayTextChange)="fields.project.control.displayText=$event"
                            [placeholder]="fields.project.control.placeholder"
                            [styles]="fields.project.control.styles"
                            [tooltip]="fields.project.control.tooltip"
                        >
                        </ProgrammableLogicController-projects_dd_single>
                        <ng-container *ngIf="fields.project.invalid">
                          <ng-container *ngFor="let error of fields.project.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-connector_name" *ngIf="!fields.connector_name.hidden && !fields.connector_name.removed" 
                            class="field-container double {{fields.connector_name.invalid ? 'invalid' : ''}} {{fields.connector_name.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.connector_name.styles.style"
                            [ngClass]="fields.connector_name.styles.classes">
                        <div *ngIf="fields.connector_name.label" class="label-container"
                             [matTooltip]="fields.connector_name.tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.connector_name.label}}<span *ngIf="fields.connector_name.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <ProgrammableLogicController-connector_settings_single 
                            data-cy="selector"
                            [type]="fields.connector_name.control.type"
                            formControlName="connector_name"
                            (displayTextChange)="fields.connector_name.control.displayText=$event"
                            [placeholder]="fields.connector_name.control.placeholder"
                            [styles]="fields.connector_name.control.styles"
                            [tooltip]="fields.connector_name.control.tooltip"
                        >
                        </ProgrammableLogicController-connector_settings_single>
                        <ng-container *ngIf="fields.connector_name.invalid">
                          <ng-container *ngFor="let error of fields.connector_name.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-plc_type" *ngIf="!fields.plc_type.hidden && !fields.plc_type.removed" 
                            class="field-container full {{fields.plc_type.invalid ? 'invalid' : ''}} {{fields.plc_type.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.plc_type.styles.style"
                            [ngClass]="fields.plc_type.styles.classes">
                        <div *ngIf="fields.plc_type.label" class="label-container"
                             [matTooltip]="fields.plc_type.tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.plc_type.label}}<span *ngIf="fields.plc_type.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <ProgrammableLogicController-plc_type_dd_single 
                            data-cy="selector"
                            [type]="fields.plc_type.control.type"
                            formControlName="plc_type"
                            (displayTextChange)="fields.plc_type.control.displayText=$event"
                            [placeholder]="fields.plc_type.control.placeholder"
                            [styles]="fields.plc_type.control.styles"
                            [tooltip]="fields.plc_type.control.tooltip"
                        >
                        </ProgrammableLogicController-plc_type_dd_single>
                        <ng-container *ngIf="fields.plc_type.invalid">
                          <ng-container *ngFor="let error of fields.plc_type.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-order_class" *ngIf="!fields.order_class.hidden && !fields.order_class.removed" 
                            class="field-container full {{fields.order_class.invalid ? 'invalid' : ''}} {{fields.order_class.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.order_class.styles.style"
                            [ngClass]="fields.order_class.styles.classes">
                        <div *ngIf="fields.order_class.label" class="label-container"
                             [matTooltip]="fields.order_class.tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.order_class.label}}<span *ngIf="fields.order_class.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <ProgrammableLogicController-orderclasses_dd_single 
                            data-cy="selector"
                            [type]="fields.order_class.control.type"
                            formControlName="order_class"
                            (displayTextChange)="fields.order_class.control.displayText=$event"
                            [placeholder]="fields.order_class.control.placeholder"
                            [styles]="fields.order_class.control.styles"
                            [tooltip]="fields.order_class.control.tooltip"
                        >
                        </ProgrammableLogicController-orderclasses_dd_single>
                        <ng-container *ngIf="fields.order_class.invalid">
                          <ng-container *ngFor="let error of fields.order_class.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.Configuration.expanded">
        
        
                    </div>
                  </div>
                </div>
              </div>
      </ng-container>

    </div>
  </div>
</div>